import { supabase } from './supabase';

type RpcResult<T>={data:T|null;error:{message:string}|null};
async function rpc<T>(name:string,args:Record<string,unknown>):Promise<RpcResult<T>>{
  const r=await supabase.rpc(name,args);
  return{data:(r.data??null) as T|null,error:r.error?{message:r.error.message}:null};
}

export type QualityCheckpoint='post_install'|'pre_teardown'|'receiving_inspection';
export type DamagePart={
  product_id:string;
  sku:string|null;
  name:string;
  unit_of_measure:string|null;
  unit_cost:number;
};
export type JobQualityWorkspace={
  contract_version:string;
  organization_id:string;
  job_id:string;
  checkpoint:QualityCheckpoint;
  title:string;
  instructions:string;
  check:{
    status:'pending'|'completed';
    damage_flagged:boolean;
    damage_attribution:'none'|'crew'|'customer'|'carrier'|string;
    damaged_product_id:string|null;
    damaged_quantity:number|null;
    damage_unit_cost:number|null;
    notes:string|null;
    completed_at:string|null;
    photo_count:number;
    maintenance_work_order_number:string|null;
    damage_claim_number:string|null;
  };
  damage_parts:DamagePart[];
  capabilities:{update:boolean};
};
export type QualityCompletion={
  quality_check_id:string;
  checkpoint:QualityCheckpoint;
  damage_flagged:boolean;
  damage_attribution:string;
  maintenance_work_order_id:string|null;
  maintenance_work_order_number:string|null;
  damage_claim_invoice_id:string|null;
  damage_claim_number:string|null;
};

export const jobQualityApi={
  workspace:(jobId:string,checkpoint:QualityCheckpoint)=>rpc<JobQualityWorkspace>('get_job_quality_check_workspace',{p_job_id:jobId,p_checkpoint:checkpoint}),
  complete:(jobId:string,checkpoint:QualityCheckpoint,damageFlagged:boolean,notes:string|null,productId:string|null,quantity:number)=>
    rpc<QualityCompletion>('complete_field_quality_check',{
      p_job_id:jobId,p_checkpoint:checkpoint,p_damage_flagged:damageFlagged,p_notes:notes,
      p_product_id:productId,p_quantity:quantity,
    }),
};
